import React from "react";
import Meta from "../../components/Meta";
import CalendarSection from "../../components/Custom/CalendarSection";
import { useAuth, requireAuth } from "./../../util/auth";
import SideNav from "../../components/Custom/SideNav";
import StateFarmCheckModal from "../../components/Custom/StateFarmCheckModal";

function CalendarPage(props) {
  const auth = useAuth()
  return (
    <>
      <Meta title="Calendar"/>
      {auth.user&&(
        <CalendarSection uid = {auth.user.uid}/>
      )}      
      <SideNav current = "calendar"></SideNav>
      <StateFarmCheckModal onDone={() => null}/>
    </>
  );
}

export default requireAuth(CalendarPage);
